import { TreeCheckboxSelectionKeys } from 'primereact/tree';

import { TreeNode } from '../types/interfaces';

export const transformToSelectionKeys = (
  selectedNodes: any[],
  allNodes: TreeNode[]
): TreeCheckboxSelectionKeys => {
  const selectionKeys: TreeCheckboxSelectionKeys = {};

  // Check if selectedNodes is actually an array before continuing
  if (!Array.isArray(selectedNodes) || selectedNodes.length === 0) {
    return selectionKeys; // return empty if selectedNodes is not valid
  }

  // Helper function to recursively process each node
  const processNode = (node: TreeNode): boolean => {
    let isFullyChecked = false;
    let hasPartialChecks = false;

    // Check if the current node is explicitly selected
    if (
      selectedNodes.some((selected) => selected && selected.key === node.key)
    ) {
      selectionKeys[node.key] = { checked: true, partialChecked: false };
      isFullyChecked = true;
    }

    // If the node has children, process them recursively
    if (node.children && node.children.length > 0) {
      let totalChecked = 0;
      let totalPartial = 0;

      node.children.forEach((child) => {
        const childFullyChecked = processNode(child);

        if (selectionKeys[child.key]?.checked) {
          totalChecked++;
        }
        if (selectionKeys[child.key]?.partialChecked) {
          totalPartial++;
        }

        hasPartialChecks =
          hasPartialChecks || !!selectionKeys[child.key]?.partialChecked;
        isFullyChecked = isFullyChecked && childFullyChecked;
      });

      // Update the current node's status based on children
      if (totalChecked === node.children.length) {
        selectionKeys[node.key] = { checked: true, partialChecked: false };
        isFullyChecked = true;
      } else if (totalChecked > 0 || totalPartial > 0 || hasPartialChecks) {
        selectionKeys[node.key] = { checked: false, partialChecked: true };
        hasPartialChecks = true;
      } else {
        // If none of the children are selected, ensure the parent is not selected
        if (selectionKeys[node.key]) {
          delete selectionKeys[node.key];
        }
        isFullyChecked = false;
        hasPartialChecks = false;
      }
    }

    return isFullyChecked && !hasPartialChecks;
  };

  // Process all nodes from the hierarchy
  allNodes.forEach((node) => processNode(node));

  return selectionKeys;
};
